<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="permission_routers"></sidebar-item>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
export default {
  name: 'sidebar',
  components: {
    SidebarItem
  },
  computed: {
    ...mapGetters([
      'permission_routers'
    ])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue